module.exports = __webpack_public_path__ + "img/考试宝典网.c729c63e.jpg";